import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
})
export class RadioButtonComponent  implements OnInit {

  @ViewChild('radioButton') radioButton: ElementRef<HTMLInputElement>;
  
  @Output() checkedChange: EventEmitter<boolean> = new EventEmitter();
  @Input() values: string[] = [];

  // @Input() showError: boolean = true;
  // @Input() disabled: boolean = false;
  // @Input() readonly: boolean = false;

  @Input() inputGroup: FormGroup;
  @Input() fieldName: string = 'inputData';

  constructor(private fb: FormBuilder) { }

  public ngOnInit(): void {
    if (!this.inputGroup) {
      this.inputGroup = this.fb.group({
        inputData: [],
      });
    }
  }

  public ngAfterViewInit(): void {
    // this.radioButton?.nativeElement?.addEventListener('click', this.preventClick.bind(this))
  }

  public ngOnDestroy(): void {
    // this.radioButton.nativeElement.removeEventListener('click', this.preventClick.bind(this))
  }

  public onChange(): void {
  }

  private preventClick(e: Event) {
    // if (this.readonly || this.disabled) {
    //   e.stopPropagation();
    //   e.preventDefault();
    // }
  }

}
